import { Injectable } from '@angular/core';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { RestMaintenanceService } from 'src/app/service/rest/maintenance/rest-maintenance.service';
import { EventAcademy } from '../event/event.model';
import { Maintenance, MaintenanceReminder, MaintenanceReminderUser } from '../maintenance/maintenance.model';
import { News } from '../news/news.model';
import { UserService } from '../user/user.service';
import { AgendaCardType } from '../utils.model';
import * as moment from 'moment';
import { PageService } from 'src/app/service/utils/page.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { PageDialogService } from 'src/app/service/utils/page-dialog.service';
import { CalendarService } from 'src/app/service/utils/calendar.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AgendaRepositoryService {

  private _userNews: News[] = [];
  private _userAgenda: any[] = [];
  private _userNotificationCount: number = -1;

  constructor(private agendaRestService: RestAgendaService,
    private calendarService : CalendarService,
    private translate: TranslateFirebaseService,
    private pageDialogService : PageDialogService,
    private pageService: PageService,
    private userService : UserService) { }

  public get userNews(): News[] {
    let savedUserNews: any[];
    if (!this._userNews) {
      savedUserNews = JSON.parse(sessionStorage.getItem(environment.storage.news));
      return savedUserNews;
    } else return this._userNews;
  }
  public set userNews(value: News[]) {
    sessionStorage.setItem(environment.storage.news, JSON.stringify(value));
    this._userNews = value;
  }

  public get userAgenda(): any[] {
    let savedUserAgenda: any[];
    if (!this._userAgenda) {
      savedUserAgenda = JSON.parse(sessionStorage.getItem(environment.storage.agenda));
      return savedUserAgenda;
    } else return this._userAgenda;
  }

  public set userAgenda(value: any[]) {
    sessionStorage.setItem(environment.storage.agenda, JSON.stringify(value));
    this._userAgenda = value;
  }

  public get userNotificationCount(): number {
    return this._userNotificationCount;
  }
  public set userNotificationCount(value: number) {
    this._userNotificationCount = value;
  }

  getAllAgendaByUser() {
    this.agendaRestService.getAgendaElementsByUser(this.userService.eliotUser.language)
    .subscribe(result => {
      this.userAgenda = [];
        this.userNews = [];
        if(result) result.forEach((elem: News | EventAcademy | MaintenanceReminderUser | MaintenanceReminder) => {
          let elemType = elem.type;
          if (elem.expireAt) elem.expireAt = new Date(elem.expireAt?.toString());
          switch (elemType) {
            case AgendaCardType.NEWS:
              this.userNews.push(elem);
              break;
              case AgendaCardType.ACADEMY:
                this.userAgenda.push(elem);
                break;
                case AgendaCardType.EVENT:
              this.userAgenda.push(elem);
              break;
            case AgendaCardType.MAINTENANCE_USER:
              this.userAgenda.push(elem);
              break;
            case AgendaCardType.MAINTENANCE:
              this.userAgenda.push(elem);
              break;
          }

        })

      this.getCalendarDatesByMonthAndYear(Number(moment().format('MM')), Number(moment().format('YYYY')));
      this.calendarService.buildRows();
      });
  }

  getAgendaElementsByDate(date: Date): EventAcademy[] | MaintenanceReminderUser[] | MaintenanceReminder[] {
    return this.userAgenda
      .filter((element: EventAcademy | MaintenanceReminderUser | MaintenanceReminder) => date == undefined || element.expireAt.setHours(0,0,0,0) == date.setHours(0,0,0,0));
  }

  getAgendaDates() {
      return this.userAgenda
        .map((element: EventAcademy | MaintenanceReminderUser | MaintenanceReminder)   => element.expireAt)
        .filter((ele, index, array) => array.findIndex(i => i.setHours(0,0,0,0) === ele?.setHours(0,0,0,0)) == index)
        .sort((a, b) => (a > b ? 1 : -1));
  }

  getAgendaElementById(elementId : number) {
    return this.agendaRestService.getAgendaElementById(elementId);
  }

  getUserReminderById(elementId : number) {
    return this.agendaRestService.getUserReminderById(elementId);
  }

  getMaintenanceReminderById(elementId : number) {
    return this.agendaRestService.getMaintenanceReminderById(elementId);
  }

  getUserNotificationCount() {
    this.agendaRestService.getNotificationCount(this.userService.eliotUser.language)
      .subscribe((result: number) => {
        if (result) this.userNotificationCount = result;
      });
  }

  hideElement(elementId : number) {
    this.agendaRestService.hideAgendaElement(elementId)
      .subscribe((result) => {
        const indexToDelete = this.userAgenda.findIndex(elem => elem.id === elementId);
        if (indexToDelete > -1) this.userAgenda.splice(indexToDelete, 1);
        this.pageService.openSnackBar(this.parseByType(this.translate.getTranslation('general_delete_success')), 'Ok');
      }, error => {
        this.pageService.openErrorSnackBar(this.parseByType(this.translate.getTranslation('general_delete_failed')), 'Ok');
      })
  }

  hideNews(elementId : number) {
    this.agendaRestService.hideAgendaElement(elementId)
      .subscribe((result) => {
        const indexToDelete = this.userNews.findIndex(news => news.id === elementId);
        if(indexToDelete> -1)this.userNews.splice(indexToDelete, 1);
        this.pageService.openSnackBar(this.translate.getTranslation('general_delete_success').replace('{0}', this.translate.getTranslation('agenda_news')), 'Ok')
      }, error => {
        this.pageService.openErrorSnackBar(this.translate.getTranslation('general_delete_failed').replace('{0}', this.translate.getTranslation('agenda_news')), 'Ok')
      })
  }

  getCalendarDatesByMonthAndYear(month: number, year: number) {
    this.calendarService.eventDays = [];
    this.userAgenda.forEach((element: EventAcademy | MaintenanceReminderUser | MaintenanceReminder) => {
      let date: Date = new Date(element.expireAt);
      if (date.getUTCMonth() + 1 == month
        && date.getUTCFullYear() == year) this.calendarService.eventDays.push({ day : date.getDate(), month : date.getUTCMonth() + 1 })
    })
  }

  parseByType(trad: string): string {
    switch (this.pageDialogService.agendaType) {
      case AgendaCardType.EVENT:
        trad = trad.replace('{0}', this.translate.getTranslation('event_title'));
        break;
      case AgendaCardType.ACADEMY:
        trad = trad.replace('{0}', this.translate.getTranslation('academy_title'));
    }

    return trad;
  }
}
